// extracted by mini-css-extract-plugin
export default {"app":"app__F3dG8","text-center":"text-center__cq7bR","error-color":"error-color__EGlbR","loading":"loading__jZW7O","wrapper":"wrapper__qa3Gp","text":"text__6+sqx"};